import { Box } from "@mui/material";

export function VideoPlayerSkeleton() {
    return (
        <Box component='div' className='skeleton' sx={{ width: "100%", paddingBottom: "56.25%", position: "relative" }}>
            <Box component='div' className='fake' sx={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }} />
        </Box>
    );
} 
